export default __webpack_public_path__ + "static/media/maria.da4b709b.JPG";